export default "__VITE_ASSET__COydHeYD__"